'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const PriceBarPriceInfo = renderWithRef('PriceBarPriceInfo', null, (o, i)=>{
    let { accessibleText: c } = o, p = _object_without_properties(o, [
        "accessibleText"
    ]);
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: i,
        classNames: new Set([
            'swan-price-bar-price-info'
        ]),
        props: p,
        children: jsx(Button, {
            skin: "unstyled",
            children: jsx(Icon, {
                alt: c || '',
                iconType: "info",
                size: "16p"
            })
        })
    });
});

export { PriceBarPriceInfo };
